


import {initWebComponent} from "@/helpers/web-component-helper";

const template = document.createElement('template');
template.innerHTML = `
<nav class="layout-about">
    <div id="mouse-position"></div>
</nav>

`;

export class LayoutAboutComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)
    }
}
